/* Delivery-date math shared by delivery.js (browser) and scripts/delivery-date.test.js (Node).
   Pure functions, no DOM. Rules: the order is processed on "day 1" = today when it is a
   business day and the cutoff (Eastern Time) has not passed, otherwise the next business
   day; it ships on day N of lead_days (lead 1 = ships day 1); delivery = ship date + the
   zone's transit business days (min..max). Weekends and holiday_dates are skipped. */
(function (root) {
  'use strict';

  function localIso(d) {
    var mm = String(d.getMonth() + 1);
    var dd = String(d.getDate());
    return d.getFullYear() + '-' + (mm.length < 2 ? '0' + mm : mm) + '-' + (dd.length < 2 ? '0' + dd : dd);
  }

  function parseCutoff(str) {
    var m = /(\d{1,2})(?::(\d{2}))?\s*(AM|PM)/i.exec(str || '');
    if (!m) return 14 * 60;
    return ((parseInt(m[1], 10) % 12) + (/pm/i.test(m[3]) ? 12 : 0)) * 60 + (m[2] ? parseInt(m[2], 10) : 0);
  }

  function toEastern(now) {
    try {
      return new Date(now.toLocaleString('en-US', { timeZone: 'America/New_York' }));
    } catch (e) {
      return new Date(now.getTime());
    }
  }

  function isBusinessDay(d, holidays) {
    var dow = d.getDay();
    return dow !== 0 && dow !== 6 && (holidays || []).indexOf(localIso(d)) === -1;
  }

  function nextBusinessDay(d, holidays) {
    var x = new Date(d.getTime());
    do {
      x.setDate(x.getDate() + 1);
    } while (!isBusinessDay(x, holidays));
    return x;
  }

  function addBusinessDays(d, n, holidays) {
    var x = new Date(d.getTime());
    while (n > 0) {
      x = nextBusinessDay(x, holidays);
      n--;
    }
    return x;
  }

  /* opts: { now: Date, cutoffTime: '2:00 PM ET', holidayDates: [], leadDays, transitMin, transitMax } */
  function computeDelivery(opts) {
    var nowEt = toEastern(opts.now || new Date());
    var holidays = opts.holidayDates || [];
    var cutoff = parseCutoff(opts.cutoffTime);
    var day1 = new Date(nowEt.getFullYear(), nowEt.getMonth(), nowEt.getDate(), 12, 0, 0, 0);
    var afterCutoff = nowEt.getHours() * 60 + nowEt.getMinutes() >= cutoff;
    if (!isBusinessDay(day1, holidays) || afterCutoff) day1 = nextBusinessDay(day1, holidays);
    var lead = Math.max(parseInt(opts.leadDays, 10) || 0, 1);
    var ship = addBusinessDays(day1, lead - 1, holidays);
    var tMin = parseInt(opts.transitMin, 10) || 0;
    var tMax = parseInt(opts.transitMax, 10) || tMin;
    if (tMax < tMin) tMax = tMin;
    return {
      afterCutoff: afterCutoff,
      day1: day1,
      ship: ship,
      earliest: addBusinessDays(ship, tMin, holidays),
      latest: addBusinessDays(ship, tMax, holidays)
    };
  }

  function formatDate(d) {
    return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
  }

  /* "Thu, Oct 1 – Fri, Oct 2", or a single date when min == max */
  function formatRange(a, b) {
    if (localIso(a) === localIso(b)) return formatDate(a);
    return formatDate(a) + ' – ' + formatDate(b);
  }

  var api = {
    localIso: localIso,
    parseCutoff: parseCutoff,
    toEastern: toEastern,
    isBusinessDay: isBusinessDay,
    addBusinessDays: addBusinessDays,
    computeDelivery: computeDelivery,
    formatDate: formatDate,
    formatRange: formatRange
  };
  root.b2bDeliveryMath = api;
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
})(typeof window !== 'undefined' ? window : globalThis);
